import * as React from 'react';
import { IFilter } from '@wyz/types';
import { Button, Flex, Icon, RowModel, Text } from '../index';
import { useDatatableContext } from './context';
type Props<TCriteria = IFilter> = {
  onExport?: (criteria: TCriteria) => void;
};
const Header = <TDataItem extends RowModel, TCriteria = IFilter>({
  onExport,
  children,
}: React.PropsWithChildren<Props<TCriteria>>) => {
  const datatableContext = useDatatableContext<TDataItem>();
  const from = datatableContext.internals.query.data?.meta.from ?? 0;
  const to = datatableContext.internals.query.data?.meta.to ?? 0;
  const total = datatableContext.internals.query.data?.meta.total ?? 0;

  return (
    <div className='my-3 d-flex align-items-center w-100'>
      <Flex alignItems='center' className='space-x-2'>
        <Text heading='normal' weight='semi-bold'>
          {datatableContext.translations?.pagination?.showingResult
            ? datatableContext.translations?.pagination?.showingResult({
                from,
                to,
                total,
              })
            : `${total} results`}
        </Text>
        {onExport && (
          <Button
            id='export'
            variant='tertiary-blue'
            type='button'
            size='sm'
            onClick={() => {
              const currentFormValue = datatableContext.internals.state
                .transformedCriteria as TCriteria;
              onExport?.(currentFormValue);
            }}
          >
            <span>{datatableContext.translations?.exportBtn ?? 'Export'}</span>
            <Icon icon='upload-line' size='xs' />
          </Button>
        )}
      </Flex>
      {children}
    </div>
  );
};

export default Header;
